import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ViewChild,
    ElementRef,
    ChangeDetectorRef,
    AfterViewInit,
    OnDestroy
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import {UserFriendViewModel} from '../../../../shared/viewModels/userFriend.viewModel';
import {FriendsService} from '../../../../shared/services/friends.service';
import {ShoppingListComponent} from './shopping-list.component';

@Component({
    selector: 'app-friends',
    templateUrl: './friends.component.html',
    styleUrls: ['./friends.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FriendsComponent implements OnInit, AfterViewInit, OnDestroy {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    subscriptions: Subscription[] = [];
    friends: UserFriendViewModel[] = [];

    selectedFriends = [];
    shoppingListComponent: ShoppingListComponent;

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly friendsService: FriendsService,
        private readonly localisationService: LocalisationService,
        private readonly changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this.subscriptions.push(
            this.bsModalEventsEmitter.bsModalStateChanged$.pipe(filter(bsModalRef => bsModalRef === this.bsModalRef)).subscribe(() => {
                this.init();
            })
        );
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    checkFriend(event, id) {
        if (event.currentTarget.checked) {
            this.selectedFriends.push(id);
        } else {
            const new_arr = [];

            this.selectedFriends.forEach(friend_id => {
                if (id !== friend_id) {
                    new_arr.push(friend_id);
                }
            });

            this.selectedFriends = new_arr;
        }
    }

    save() {
        this.shoppingListComponent.setFriends(this.selectedFriends);
        this.bsModalRef.hide();
    }

    private init() {
        this.subscriptions.push(
            this.friendsService.getFriends().subscribe(friends => {
                this.friends = friends;
                this.changeDetectorRef.markForCheck();
            })
        );
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }
}
